import { Injectable } from '@angular/core';
import { UsrmgtService } from '../usermgt/services/usrmgt.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AcademicYearService {

  constructor(public usrMgtService: UsrmgtService) { }
  subscribe: Subject<any> = new Subject<any>();
  currentDateDto: any;
  yearList: any = [];
  academicYearList: any = []; 
  monthList = [
    { value: 1, text: 'Jan' },
    { value: 2, text: 'Feb' },
    { value: 3, text: 'Mar' },
    { value: 4, text: 'Apr' },
    { value: 5, text: 'May' },
    { value: 6, text: 'June' },
    { value: 7, text: 'July' },
    { value: 8, text: 'Aug' },
    { value: 9, text: 'Sep' },
    { value: 10, text: 'Oct' },
    { value: 11, text: 'Nov' },
    { value: 12, text: 'Dec' }
];

  // Current Date
  public getCurrentDate() {    
    this.usrMgtService.getCurrentDate().pipe(takeUntil(this.subscribe)).subscribe(res => {
      this.currentDateDto = res;
    }, error => {
      console.log(error)
    });
  }

// Current Academic Year
  public getCurrentAcademicYear() {    
    var currentyear = new Date().getFullYear();
    var nextyear = new Date().getFullYear() + 1;
    var academicYear = currentyear + "-" + nextyear.toString().substr(nextyear.toString().length - 2);
    
    if(new Date().getMonth()<6) {
      var previousyear = new Date().getFullYear() -1;
      academicYear = previousyear + "-" + currentyear.toString().substr(currentyear.toString().length - 2);
    }
    return academicYear;
  }

  public getSARCurrentAcademicYear() {    
    var currentyear = new Date().getFullYear();
    var nextyear = currentyear + 1;
    var academicYear = currentyear + "-" + nextyear.toString().substr(nextyear.toString().length - 2);
  
    if (new Date().getMonth() < 4) { 
      var previousyear = currentyear - 1;
      academicYear = previousyear + "-" + currentyear.toString().substr(currentyear.toString().length - 2);
    }
  
    return academicYear;
  }
  
  // Current Academic Year
  public getCurrentAcademicYearSAR() {    
    var currentyear = new Date().getFullYear();
    var nextyear = new Date().getFullYear() + 1;
    var academicYear = currentyear + "-" + nextyear.toString().substr(nextyear.toString().length - 2);
    
    if(new Date().getMonth()<9) {
      var previousyear = new Date().getFullYear() -1;
      academicYear = previousyear + "-" + currentyear.toString().substr(currentyear.toString().length - 2);
    }
    return academicYear;
  }

  public getCurrentAcademicYearMar() {    
    var currentyear = new Date().getFullYear();
    var nextyear = new Date().getFullYear() + 1;
    var academicYear = currentyear + "-" + nextyear.toString().substr(nextyear.toString().length - 2);
    
    if(new Date().getMonth()<3) {
      var previousyear = new Date().getFullYear() -1;
      academicYear = previousyear + "-" + currentyear.toString().substr(currentyear.toString().length - 2);
    }
    return academicYear;
  }

  //Year List
  public getYearList() {
    this.yearList = [];
    var currentdate = new Date();
    var year = currentdate.getFullYear();

    var k = 0;
    var j = 1;
    for (let i = year; i > 1999; i--) {
      k = i + 1;
      var item = { id: j, text: i.toString()};
      this.yearList.push(item);

      j = j + 1;
    }
    return this.yearList;
  }

    //Year List
    public getYearList1989() {
      this.yearList = [];
      var currentdate = new Date();  
      var year = currentdate.getFullYear();  
      var k = 0;
      var j = 1;
      for (let i = year; i > 1989; i--) {
        k = i + 1;
        var item = { id: j, text: i.toString()};
        this.yearList.push(item);
  
        j = j + 1;
      }
      return this.yearList;
    }

     //Year List
     public getYearList1999() {
      this.yearList = [];
      var currentdate = new Date();  
      var year = currentdate.getFullYear();  
      var k = 0;
      var j = 1;
      for (let i = year; i > 1999; i--) {
        k = i + 1;
        var item = { id: j, text: i.toString()};
        this.yearList.push(item);
  
        j = j + 1;
      }
      return this.yearList;
    }


  public getYearList2020() {
    this.yearList = [];
    var currentdate = new Date();
    var year = currentdate.getFullYear();

    var j = 1;
    for (let i = year; i > 2020; i--) {
      var item = { id: j, text: i.toString()};
      this.yearList.push(item);
      j = j + 1;
    }
    return this.yearList;
  }

  public getYearList2021() {
    this.yearList = [];
    var currentdate = new Date();
    var year = currentdate.getFullYear();

    var j = 1;
    for (let i = year; i > 2021; i--) {
      var item = { id: j, text: i.toString()};
      this.yearList.push(item);
      j = j + 1;
    }
    return this.yearList;
  }

   //Year List
   public getYearList1948() {
    this.yearList = [];
    var currentdate = new Date();  
    var year = currentdate.getFullYear();  
    var k = 0;
    var j = 1;
    for (let i = year; i > 1948; i--) {
      k = i + 1;
      var item = { id: j, text: i.toString()};
      this.yearList.push(item);

      j = j + 1;
    }
    return this.yearList;
  }

  //Academic Year
  public getAcademicYearList() {
    this.academicYearList = [];
    var currentdate = new Date();

    var year = currentdate.getFullYear();
    if(currentdate.getMonth() < 6) {
      year = currentdate.getFullYear() - 1;
    } 

    var k = 0;
    var j = 1;
    for (let i = year; i > 1999; i--) {
      k = i + 1;
      var lastTwoChars = k.toString().substr(k.toString().length - 2);
      var item = { id: j, text: i.toString() + "-" + lastTwoChars };
      this.academicYearList.push(item);

      j = j + 1;
    }
    return this.academicYearList;
  }

  public getAcademicYearList2011() {
    this.academicYearList = [];
    var currentdate = new Date();

    var year = currentdate.getFullYear();
    // if(currentdate.getMonth() < 3) {
    //   year = currentdate.getFullYear() - 1;
    // } 

    var k = 0;
    var j = 1;
    for (let i = year; i > 2011; i--) {
      k = i + 1;
      var lastTwoChars = k.toString().substr(k.toString().length - 2);
      var item = { id: j, text: i.toString() + "-" + lastTwoChars };
      this.academicYearList.push(item);

      j = j + 1;
    }

    return this.academicYearList;
  }
  
public getSARAcademicYearList2020() {
  this.academicYearList = [];
  const currentdate = new Date();

  let year = currentdate.getFullYear();
  // ✅ If current month is May or earlier, start from next academic year
  if (currentdate.getMonth() === 4) { // Jan=0, May=4
   year = year + 1;  } 

  let k = 0;
  let j = 1;

  for (let i = year; i > 2020; i--) {
    k = i + 1;
    const lastTwoChars = k.toString().substr(k.toString().length - 2);
    const item = { id: j, text: i.toString() + "-" + lastTwoChars };
    this.academicYearList.push(item);
    j++;
  }

  return this.academicYearList;
}

// public getSARAcademicYearList2020() {
//   this.academicYearList = [];

//   const currentDate = new Date();
//   let year = currentDate.getFullYear();

//   if (currentDate.getMonth() >= 4) {
//     year = year + 1;
//   }

//   let id = 1;

//   for (let i = year - 1; i > 2020; i--) {
//     const nextYear = i + 1;
//     const item = {
//       id: id++,
//       text: `${i}-${nextYear.toString().slice(-2)}`
//     };
//     this.academicYearList.push(item);
//   }

//   return this.academicYearList;
// }

  public getAcademicYearList2020() {
    this.academicYearList = [];
    var currentdate = new Date();

    var year = currentdate.getFullYear();
    if(currentdate.getMonth() < 6) {
      year = currentdate.getFullYear() - 1;
    } 

    var k = 0;
    var j = 1;
    for (let i = year; i > 2020; i--) {
      k = i + 1;
      var lastTwoChars = k.toString().substr(k.toString().length - 2);
      var item = { id: j, text: i.toString() + "-" + lastTwoChars };
      this.academicYearList.push(item);

      j = j + 1;
    }

    return this.academicYearList;
  }

  public getAcademicYearListInsp2020() {
  this.academicYearList = [];
  var currentdate = new Date();

  var year = currentdate.getFullYear();
  if (currentdate.getMonth() < 6) {
    year = currentdate.getFullYear() - 1;
  }

  var k = 0;
  var j = 1;

  for (let i = year + 1; i > 2020; i--) {
    k = i + 1;
    var lastTwoChars = k.toString().substr(k.toString().length - 2);
    var item = { id: j, text: i.toString() + "-" + lastTwoChars };
    this.academicYearList.push(item);

    j = j + 1;
  }

  return this.academicYearList;
}

  public getAcademicYearList2024() {
    this.academicYearList = [];
    var currentdate = new Date();

    var year = currentdate.getFullYear();
    // if(currentdate.getMonth() < 6) {
    //   year = currentdate.getFullYear() - 1;
    // } 

    var k = 0;
    var j = 1;
    for (let i = year; i > 2020; i--) {
      k = i + 1;
      var lastTwoChars = k.toString().substr(k.toString().length - 2);
      var item = { id: j, text: i.toString() + "-" + lastTwoChars };
      this.academicYearList.push(item);

      j = j + 1;
    }

    return this.academicYearList;
  }

  public getAcademicYearList2020Mar() {
    this.academicYearList = [];
    var currentdate = new Date();

    var year = currentdate.getFullYear();
    if(currentdate.getMonth() < 3) {
      year = currentdate.getFullYear() - 1;
    } 

    var k = 0;
    var j = 1;
    for (let i = year; i > 2020; i--) {
      k = i + 1;
      var lastTwoChars = k.toString().substr(k.toString().length - 2);
      var item = { id: j, text: i.toString() + "-" + lastTwoChars };
      this.academicYearList.push(item);

      j = j + 1;
    }

    return this.academicYearList;
  }

  public getAcademicYearList2019() {
    this.academicYearList = [];
    var currentdate = new Date();

    var year = currentdate.getFullYear();
    if(currentdate.getMonth() < 6) {
      year = currentdate.getFullYear() - 1;
    } 

    var k = 0;
    var j = 1;
    for (let i = year; i > 2019; i--) {
      k = i + 1;
      var lastTwoChars = k.toString().substr(k.toString().length - 2);
      var item = { id: j, text: i.toString() + "-" + lastTwoChars };
      this.academicYearList.push(item);

      j = j + 1;
    }

    return this.academicYearList;
  }

  public getAcademicYearList1948() {
    this.academicYearList = [];
    var currentdate = new Date();

    var year = currentdate.getFullYear();
    if(currentdate.getMonth() < 6) {
      year = currentdate.getFullYear() - 1;
    } 

    var k = 0;
    var j = 1;
    for (let i = year; i > 1948; i--) {
      k = i + 1;
      var lastTwoChars = k.toString().substr(k.toString().length - 2);
      var item = { id: j, text: i.toString() + "-" + lastTwoChars };
      this.academicYearList.push(item);

      j = j + 1;
    }

    return this.academicYearList;
  }

  public getMonthNameList() {   
    return this.monthList;
  }

  public getNextAcademicYear(currentAY: any) {
      var parts = currentAY.split("-");
      var nextAY = `${Number(parts[0]) + 1}-${(Number(parts[0])+ 2).toString().slice(-2)}`
      return nextAY;
  }

  public getUpcomingAcademicYearList() {
    this.academicYearList = [];
    var currentdate = new Date();

    var year = currentdate.getFullYear();
    if(currentdate.getMonth() < 7) {
      year = currentdate.getFullYear() - 1;
    } 

    var k = 0;
    var j = 1;
    for (let i = year; i < year + 3; i++) {
      k = i + 1;
      var lastTwoChars = k.toString().substr(k.toString().length - 2);
      var item = { id: j, text: i.toString() + "-" + lastTwoChars };
      this.academicYearList.push(item);

      j = j + 1;
    }

    return this.academicYearList;
  }

  public getAcademicYearListYearStart() {
    this.academicYearList = [];
    var currentdate = new Date();

    var year = currentdate.getFullYear();

    var k = 0;
    var j = 1;
    for (let i = year; i > 2020; i--) {
      k = i + 1;
      var lastTwoChars = k.toString().substr(k.toString().length - 2);
      var item = { id: j, text: i.toString() + "-" + lastTwoChars };
      this.academicYearList.push(item);

      j = j + 1;
    }

    return this.academicYearList;
  }

//   public getAcademicYearListYearStartcauniversity() {
//   this.academicYearList = [];
//   const currentYear = new Date().getFullYear();
//   const nextYear = (currentYear + 1).toString().slice(-2);

//   this.academicYearList.push({ id: 1, text: `${currentYear}-${nextYear}` });

//   return this.academicYearList;
// }
public getAcademicYearListYearStartcauniversity() {
  this.academicYearList = [];

  const currentYear = new Date().getFullYear();
  const nextYear = (currentYear + 1).toString().slice(-2);

  // 👉 Previous Academic Year (added line)
  const prevYear = currentYear - 1;
  const prevNextYear = currentYear.toString().slice(-2);

  this.academicYearList.push(
    { id: 1, text: `${currentYear}-${nextYear}` },
    { id: 2, text: `${prevYear}-${prevNextYear}` }  
  );

  return this.academicYearList;
}
}
